import GradingFlex from 'src/commons/grading/GradingFlex';
import type { ColumnFilter, ColumnFiltersState } from 'src/features/grading/GradingTypes';

import FilterBadge from './gradingBadges/FilterBadge';

type Props = {
  filters: ColumnFiltersState;
  onFilterRemove: (filter: ColumnFilter) => void;
};

function GradingSubmissionFilters({ filters, onFilterRemove }: Props) {
  return (
    <GradingFlex
      justifyContent="flex-start"
      style={{ maxWidth: 'max(800px, 70vw)', marginRight: '10px' }}
    >
      {filters.map(filter => (
        <FilterBadge filter={filter} onRemove={onFilterRemove} key={filter.id} />
      ))}
    </GradingFlex>
  );
}

export default GradingSubmissionFilters;
